import React from 'react';
export function Headline() {
  return <div className="-mb-4" data-id="element-196">
      <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-[15px]" data-id="element-197">
        I'm 67 and Strangers Asked If I Have Work Done - Here's My 5-Minute
        Secret
      </h1>
      <p className="text-xl text-gray-700 leading-relaxed mt-[15px] mb-0" data-id="element-198">
        As a woman who's spent thousands on serums that just sat on my skin, I
        finally found what actually works
      </p>
    </div>;
}